import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * RulesModal Component
 * Displays game rules in a modal overlay
 *
 * @param {boolean} show - Whether to show the modal
 * @param {function} onClose - Callback when modal is closed
 */
const RulesModal = ({ show, onClose }) => {
  const { t } = useLanguage();

  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="rules-modal">
        <div className="rules-header">
          <h2 style={{
            textAlign: 'center',
            marginBottom: '0.5rem',
            background: 'linear-gradient(to right, #ef4444, #f59e0b, #10b981, #3b82f6)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '1.75rem',
            fontWeight: '700',
            position: 'relative',
            display: 'inline-block',
            padding: '0 1rem'
          }}>
            {t('gameRules.title')}
          </h2>
          <button
            className="close-btn"
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#6b7280',
              zIndex: 2,
              padding: '5px 10px'
            }}
          >
            &times;
          </button>
        </div>
        <div className="rules-content">
          <p>{t('gameRules.overview')}</p>

          {/* Dynamically display all game rule sections */}
          {Array.from({ length: 12 }, (_, i) => (
            <React.Fragment key={i}>
              <h3>{t(`gameRules.sections.${i}.title`)}</h3>
              <p>{t(`gameRules.sections.${i}.content`)}</p>
            </React.Fragment>
          ))}

          {/* Donation section - Temporarily disabled (no brand license yet) */}
          {/* <div style={{
            textAlign: 'center',
            marginTop: '1.5rem',
            paddingTop: '1rem',
            borderTop: '1px solid #e5e7eb'
          }}>
            <p style={{
              marginBottom: '1rem',
              fontSize: '0.9rem',
              color: '#374151'
            }}>
              {t('gameRules.donation')}
            </p>
            <img
              src="/bmc_qr.png"
              alt="Scan QR code to support Qwixx Online with a coffee donation"
              style={{
                maxWidth: '200px',
                height: 'auto',
                margin: '0 auto',
                display: 'block'
              }}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default RulesModal;
